import { isEmpty } from 'lodash';
import { IBooleanCondition } from '../../../inputs/expressions-editor/conditions/IBooleanCondition';
import { IUseExpressionValue } from '../../expressions/render/hooks/useExpressionValue';

/**
 * Converte il risultato di una condizione in un valore booleano, a prescindere
 * che sia una condizione statica o un'espressione.
 * Attenzione: se l'espressione non è presente, ritorna sempre `true`
 * (es. abilitato & visibile)
 */
export function conditionResultToBoolean(
  condition: IBooleanCondition | null | undefined,
  result: IUseExpressionValue,
) {
  // Se non c'è una condizione, ritorniamo `true` (es. visibile & abilitato)
  if (condition == null || isEmpty(condition)) return true;

  // Se è una condizione statica, ritorniamo il valore configurato
  if (condition.type === 'static') return condition.value;

  // Se è stato risolto il valore dell'espressione, lo ritorniamo
  if (result.type === 'value') return Boolean(result.result);

  // Se l'espression ritorna `null` (non è stato possibile calcolarla),
  // assumiamo sempre che sia `false`, es. nascosto o disabilitato
  return false;
}
